package uz.ferro.erp.feature.appuser.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.api.suspendPost
import uz.ferro.erp.api.suspendPut
import uz.ferro.erp.feature.appuser.model.UserDto

object UserRepository {
    suspend fun getUsers(): List<UserDto> {
        return suspendGet("user/list")
    }

    suspend fun addUser(dto: UserDto): UserDto? {
        return suspendPost("user", body = dto)
    }

    suspend fun updateUser(dto: UserDto): UserDto? {
        return suspendPut("user", body = dto)
    }

    suspend fun getUser(id: Long): UserDto? {
        return suspendGet("user/$id")
    }
}